var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-info"},[_c('v-layout',{staticClass:"mb-2",attrs:{"align-center":""}},[_c('v-icon',{attrs:{"color":"info"}},[_vm._v(_vm._s(_vm.icon))]),_c('h3',{staticClass:"icon-info__title"},[_vm._v(_vm._s(_vm.iconTitle))])],1),_c('p',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }